import { Fragment } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';

// components
import { SbSharedRefineMenuInputRangeCurrency } from '../../SbSharedRefineMenu/SbSharedRefineMenuInputRange/SbSharedRefineMenuInputRangeCurrency';
import { SbSharedRefineMenuPriceRanges } from '../../SbSharedRefineMenu/SbSharedRefineMenuPriceRanges/SbSharedRefineMenuPriceRanges';
import { SbSharedRefineMenuSaleInput } from '../../SbSharedRefineMenu/SbSharedRefineMenuSaleInput/SbSharedRefineMenuSaleInput';

export const SbRespRefineMenuFilterPriceComponent = props => (
    <Fragment>
        <SbSharedRefineMenuPriceRanges {...props} />
        <SbSharedRefineMenuInputRangeCurrency {...props} showInvalidRangeErrorMessage={false} />
        <SbSharedRefineMenuSaleInput {...props} />
    </Fragment>
);

export const SbRespRefineMenuFilterPrice = createFragmentContainer(
    SbRespRefineMenuFilterPriceComponent,
    {
        user: graphql`
            fragment SbRespRefineMenuFilterPrice_user on User {
                ...SbSharedRefineMenuPriceRanges_user
            }
        `,
        itemSearch: graphql`
            fragment SbRespRefineMenuFilterPrice_itemSearch on ItemSearchQueryConnection {
                ...SbSharedRefineMenuPriceRanges_itemSearch
                ...SbSharedRefineMenuInputRangeCurrency_itemSearch
                ...SbSharedRefineMenuSaleInput_itemSearch
            }
        `,
    }
);
